import React from "react";
import Login from "./Login";
import Register from "./Register";
import Dialog from "@material-ui/core/Dialog";

class LoginRegister extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mode: "login"
        };
        this.switchToRegister = this.switchToRegister.bind(this);
        this.close = this.close.bind(this);
    }
    close(){
        this.props.onClose();
        setTimeout(()=>this.setState({
            mode:"login",
        }),500);
    }
    switchToRegister() {
        this.setState({ mode: "register" });
    }
    render() {
        const { open, methods, appState } = this.props;
        const { mode } = this.state;
        return (
            <Dialog open={open} onClose={this.close} scroll="body" className="my-dialog">
                {mode === "login" ?
                    <Login onSwitchToRegister={this.switchToRegister} methods={methods} onClose={this.close}/>
                :
                    <Register appState={appState} methods={methods} onClose={this.close}/>
                }
            </Dialog>
        );
    }
}

export default LoginRegister;
